// ##############################
// // // Modal component styles
// #############################

const modalStyle = {
  modal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "400px",
    boxShadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12)",
    backgroundColor: "#fff",
    borderRadius: "6px",
    height: "96%",
    overflowY: "auto"
  },
  modalHeader: {
    borderBottom: "none",
    paddingTop: "24px",
    paddingRight: "24px",
    paddingBottom: "0",
    paddingLeft: "24px",
    minHeight: "16.43px"
  },
  modalTitle: {
    display: "inline-block",
    margin: "0",
    lineHeight: "1.42857143",
    paddingRight: "40px"
  },
  modalCloseButton: {
    color: "#999999",
    //marginTop: "-12px",
    WebkitAppearance: "none",
    padding: "0",
    cursor: "pointer",
    background: "0 0",
    border: "0",
    fontSize: "25px", //"inherit",
    opacity: ".9",
    textShadow: "none",
    fontWeight: "400", //"700",
    lineHeight: "1.4", //"1",
    //float: "right"
    position: "absolute",
    top: "24px",
    right: "24px"
  },
  modalClose: {
    // width: "16px",
    // height: "16px"
    padding: "0 12px"
  },
  modalBody: {
    paddingTop: "24px",
    paddingRight: "24px",
    paddingBottom: "32px",
    paddingLeft: "24px",
    position: "relative"
  },
  modalFooter: {
    padding: "0 15px 24px",
    textAlign: "right",
    margin: "0"
  },
  modalFooterCenter: {
    marginLeft: "auto",
    marginRight: "auto"
  },
  instructionNoticeModal: {
    marginBottom: "25px"
  },
  imageNoticeModal: {
    maxWidth: "150px"
  },
  modalSmall: {
    width: "300px"
  },
  modalSmallBody: {
    paddingTop: "0"
  },
  modalSmallFooterDeleteButton: {
    float: "left",
    margin: "-6px 0"
  },
  modalSmallFooterFirstButton: {
    margin: "0",
    paddingLeft: "16px",
    paddingRight: "16px",
    width: "auto"
  },
  modalSmallFooterSecondButton: {
    marginBottom: "0",
    marginLeft: "5px"
  },
  metaError: {
    color: '#f54236'
  },
  modalSelect: {
    textAlign: "left"
  },
};

export default modalStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-dashboard-pro-react/modalStyle.jsx